var exports = {
  "w": "xfd349460--6d05f7--loader",
  "x": "xfd349460--6d05f7--skeleton-animation",
};

module.exports = exports;
